import { FC } from 'react';

import { Stack } from '@mui/material';

import { InstructionsDecorator } from 'pages/BusinessToolPage/components/InstructionsDecorator';

// import { useChangeSections } from 'hooks/useChangeSections';
// import { useSwipe } from 'hooks/useSwipe';

import { AIAssistantAlertCard } from 'components/BusinessToolForm/components/AIAssistantAlertCard/AIAssistantAlertCard';

import { IBusinessPageToolLayoutProps } from './types';

import styles from './BusinessToolPageMobileLayout.module.scss';

export const MobileLayout: FC<IBusinessPageToolLayoutProps> = ({
  header,
  form,
  modeSwitch,
  sectionsNavigation,
  navigationButtons,
}) => {
  // TODO Turned off for a while
  // const { setPrevSection, setNextSection } = useChangeSections();
  // const swipeHandlers = useSwipe({ onSwipedLeft: setNextSection, onSwipedRight: setPrevSection });

  return (
    <>
      <div>
        <Stack spacing={3} useFlexGap>
          <div className={styles['header']}>{header}</div>
          {modeSwitch}
          <div className={styles['section_navigation_wrapper']}>{sectionsNavigation}</div>
        </Stack>
        <div className={styles['content']}>{form}</div>
        {navigationButtons && <div className={styles['footer']}>{navigationButtons}</div>}
      </div>
      <AIAssistantAlertCard isMobileView />
      <InstructionsDecorator />
    </>
  );
};
